import { Directive, ElementRef, HostListener } from '@angular/core';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';

@Directive({
  selector: '[appUploadInput]'
})
export class UploadInputDirective {

  private _filePipe = new Subject<FileList>();

  constructor(
    private _elementRef: ElementRef<HTMLInputElement>
  ) { }

  @HostListener('input', ["$event"])
  fileInput = (event) => {
    this._filePipe.next(event.target.files);
  }

  trigger(){
    this._elementRef.nativeElement.click();
    (this._elementRef.nativeElement as HTMLInputElement).value = null;
    return this._filePipe.pipe(take(1));
  }

}
